<div class="modal-background">
	<div *ngIf="!staticBackground" class="click-layer" (click)="emitCancel()"></div>
	<div class="modal-container">
		<div class="hrz-between">
			<h2 class="no-mt">{{title}}</h2>
			<i *ngIf="!hideX" class="material-icons clear clickable" (click)="emitCancel()">clear</i>
		</div>
		<p  [innerHTML]="_message"></p>
		<div *ngIf="template">
			<ng-container *ngTemplateOutlet="template"></ng-container>
		</div>
		<div class="hrz-end mt-10">
			<button *ngIf="cancel" class="basic-btn-grey md-mx" (click)="emitCancel()">{{cancel}}</button>
      <button *ngIf="action" class="basic-btn-red md-mx" (click)="emitAction()" [disabled]="disableAction">{{action}}</button>
		</div>
	</div>
</div>
